import { render, staticRenderFns } from "./Recurso.vue?vue&type=template&id=d26ccffa&"
import script from "./Recurso.vue?vue&type=script&lang=js&"
export * from "./Recurso.vue?vue&type=script&lang=js&"
import style0 from "./Recurso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports